const faqOpeners = document.querySelectorAll('.faq-dropdown [data-opener]');
for (var i = 0; i < faqOpeners.length; i++) {
  faqOpeners[i].addEventListener('click', function(e) {
    if (this.classList.contains('active'))
      this.classList.remove('active');
    else
      this.classList.add('active');
  });
}

const faqHeadLinks = document.querySelectorAll('[data-section-type="faq-heading"] a');
faqHeadLinks.forEach((headLink) => {
  const href = headLink.getAttribute('href');
  if(href[0] == '#') {
    headLink.addEventListener('click', (e) => {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(href).offset().top - 150
      }, 700);
    })
  }
});